module.exports = __webpack_public_path__ + "static/media/id-guide.d3992301.png";